import { useEffect } from "react";
import { EditProjectSettingsButtons } from "components/templates";
import { Accordion, Form, Pane } from "components/materials";

export function EditMriConfigurationPanel({
  dirty,
  form,
  loading,
  onToggle,
  open,
  panelKey,
  setPanelDirty,
  ...props
}) {
  useEffect(() => {
    const isDirty = form.dirty;
    if (isDirty !== dirty) {
      setPanelDirty(panelKey, isDirty);
    }
    return undefined;
  }, [dirty, form, panelKey, setPanelDirty]);

  return (
    <Accordion.Panel
      panelKey={panelKey}
      title="Mri Configuration"
      onClick={() => onToggle(panelKey)}
      open={open}
      actionContent={
        <EditProjectSettingsButtons
          dirty={dirty}
          form={form}
          loading={loading}
        />
      }
      {...props}
    >
      <Form.Group aligned renderedChildrenDirectly>
        <Pane width={250}>
          <Form.Input label="Job Code" name="jobCode" />
        </Pane>
        <Pane width={250}>
          <Form.Input label="Cost List" name="mriCostList" />
        </Pane>
      </Form.Group>
    </Accordion.Panel>
  );
}
